// extracted by mini-css-extract-plugin
export default {"container":"InfoPage_container__04a-s","img":"InfoPage_img__gv3Vv","title":"InfoPage_title__EPMYX","text":"InfoPage_text__b2B58","link":"InfoPage_link__X-ihI"};